// extracted by mini-css-extract-plugin
module.exports = {"active":"ItemSelect_active","details":"ItemSelect_details"};